import {submitLoginApi } from "../api/loginApi";
import {requestStarted,requestCompleted} from "./common";

export const setLogOut = () => {
  return{
    type : "LOGOUT"
  }
}

export const setLogin =(authClient) => {
  return {
    type : "SET_AUTH_CLIENT",
    authClient
  }
}
export const setLoginFail =(authFailResponse) => {
  return {
    type : "SET_LOGIN_FAIL",
    authFailResponse
  }
}


export const setMessageFail =() => {
  return {
    type : "SET_MESSAGE_FAIL",
  }
}


export const logIn = (loginData) => {
  return dispatch => {
    submitLoginApi(loginData).then((response) => {
      if(response.success){
        dispatch(setLogin(response));
      }
      else {
        dispatch(setLoginFail(response));
      }
    });
  }
}

export const submitLogOut = () => {
  return dispatch => {
    submitLoginApi().then((response) => {
     dispatch(setLogOut(response));
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/login.js